export const sortByDate = (a, b) =>
  a.date < b.date ? 1 : a.date > b.date ? -1 : 0;

export const sortByKey = (a, b, key, order = 'asc') => {
  if (order === 'asc') {
    return a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0;
  }
  return a[key] < b[key] ? 1 : b[key] < a[key] ? -1 : 0;
};

//takes in a date string of 'MM/DD/YYYY'
//will be reorganized to a new date
//it will return from oldest -> newest date
// i.e. ['01/01/0001', -> '12/12/1200']
export const sortByMMDDYYY = (a, b) => {
  b = b.split('/');
  const bNewDate = new Date(b[2], b[0], b[1]);
  a = a.split('/');
  const aNewDate = new Date(a[2], a[0], a[1]);
  return aNewDate > bNewDate ? 1 : aNewDate < bNewDate ? -1 : 0;
};
